import type { Prototype } from "../prototype-types";

export const kevinLiPrototypes: Prototype[] = [
  {
    id: "kli-ads-autoinvest-gmv",
    name: "Ads autoinvest GMV",
    path: "/kli/ads-autoinvest-gmv",
    description: "Ads settings",
    owner: "Kevin Li",
    createdAt: "2026-10-08",
    lastUpdated: "2026-10-08",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/b93da19135154536215d1620e59ca6ca87f18df369b3fc6459f51d8ddc574cbb.png",
  },
];
